import Box from '@mui/material/Box';

// Dashboard card heading: the title, then an optional row count and qualifier in the secondary
// colour (same weight, colour-only contrast), e.g. "Public images with highest fix impact (5)".
const CardTitle = ({
  title,
  // count,
  subtitle,
}) => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '6px', minWidth: 0 }}>
    <Box component="span" sx={{ color: 'var(--text-primary)' }}>
      {title}
    </Box>
    {/* {count !== undefined && (
      <Box component="span" sx={{ color: 'var(--text-secondary)' }}>
        ({count})
      </Box>
    )} */}
    {subtitle && (
      <Box component="span" sx={{ color: 'var(--text-secondary)' }}>
        {subtitle}
      </Box>
    )}
  </Box>
);

export default CardTitle;
